// src/pages/AdminSwarnaprashana.jsx

import React, { useEffect, useState } from "react";


import { supabase } from "../lib/supabaseClient";
import AdminHeader from "../components/Admin/AdminHeader";

import "./AdminSwarnaprashana.css";


function AdminSwarnaprashana() {

  // =========================================================
  // STATE
  // =========================================================

  const [dates, setDates] = useState([]);

  const [loadingDates, setLoadingDates] =
    useState(false);

  const [newDate, setNewDate] =
    useState("");

  const [editingId, setEditingId] =
    useState(null);

  const [editingDate, setEditingDate] =
    useState("");

  const [error, setError] =
    useState("");

  const [success, setSuccess] =
    useState("");

  const [loading, setLoading] =
    useState(false);


  // =========================================================
  // LOAD DATES
  // =========================================================

  useEffect(() => {

    loadDates();

  }, []);


  const loadDates = async () => {

    setLoadingDates(true);
    setError("");

    const { data, error } = await supabase
      .from("swarnaprashana_schedule")
      .select("*")
      .order("date", {
        ascending: true,
      });


    if (error) {

      setError(error.message);

      setLoadingDates(false);

      return;
    }


    setDates(data || []);

    setLoadingDates(false);
  };


  // =========================================================
  // ADD DATE
  // =========================================================

  const handleAddDate = async (e) => {

    e.preventDefault();

    if (!newDate) {

      setError("Please select a date.");

      return;
    }


    setError("");
    setSuccess("");
    setLoading(true);


    const { data, error } = await supabase
      .from("swarnaprashana_schedule")
      .insert({
        date: newDate,
      })
      .select();


    if (error) {

      setError(error.message);

      setLoading(false);

      return;
    }


    if (!data || data.length === 0) {

      setError(
        "You do not have permission to add a date."
      );

      setLoading(false);

      return;
    }


    setNewDate("");

    setSuccess(
      "Swarnaprashana date added successfully."
    );

    setLoading(false);


    await loadDates();
  };


  // =========================================================
  // START EDITING
  // =========================================================

  const startEditing = (item) => {

    setError("");
    setSuccess("");

    setEditingId(item.id);

    setEditingDate(item.date);
  };


  // =========================================================
  // CANCEL EDITING
  // =========================================================

  const cancelEditing = () => {

    setEditingId(null);

    setEditingDate("");
  };


  // =========================================================
  // UPDATE DATE
  // =========================================================

  const handleUpdateDate = async (id) => {

    if (!editingDate) {

      setError("Please select a date.");

      return;
    }


    setError("");
    setSuccess("");
    setLoading(true);


    const { data, error } = await supabase
      .from("swarnaprashana_schedule")
      .update({
        date: editingDate,
      })
      .eq("id", id)
      .select();


    if (error) {

      setError(error.message);

      setLoading(false);

      return;
    }


    if (!data || data.length === 0) {

      setError(
        "You do not have permission to edit this date."
      );

      setLoading(false);

      return;
    }


    setEditingId(null);

    setEditingDate("");

    setSuccess(
      "Swarnaprashana date updated successfully."
    );

    setLoading(false);


    await loadDates();
  };


  // =========================================================
  // DELETE DATE
  // =========================================================

  const handleDeleteDate = async (id) => {

    const confirmed = window.confirm(
      "Are you sure you want to delete this Swarnaprashana date?"
    );


    if (!confirmed) {
      return;
    }


    setError("");
    setSuccess("");
    setLoading(true);


    const { data, error } = await supabase
      .from("swarnaprashana_schedule")
      .delete()
      .eq("id", id)
      .select();


    if (error) {

      setError(error.message);

      setLoading(false);

      return;
    }


    if (!data || data.length === 0) {

      setError(
        "You do not have permission to delete this date."
      );

      setLoading(false);

      return;
    }


    setSuccess(
      "Swarnaprashana date deleted successfully."
    );

    setLoading(false);


    await loadDates();
  };


  // =========================================================
  // DATE FORMAT
  // =========================================================

  const formatDate = (dateString) => {

    if (!dateString) {
      return "";
    }


    const [year, month, day] =
      dateString.split("-");


    const date = new Date(
      Number(year),
      Number(month) - 1,
      Number(day)
    );


    return date.toLocaleDateString(
      "en-IN",
      {
        day: "numeric",
        month: "long",
        year: "numeric",
      }
    );
  };


  // =========================================================
  // WEEKDAY
  // =========================================================

  const getWeekday = (dateString) => {

    if (!dateString) {
      return "";
    }


    const [year, month, day] =
      dateString.split("-");


    const date = new Date(
      Number(year),
      Number(month) - 1,
      Number(day)
    );


    return date.toLocaleDateString(
      "en-IN",
      {
        weekday: "long",
      }
    );
  };


  // =========================================================
  // PAGE
  // =========================================================

  return (

    <div className="admin-page">

      <div className="admin-dashboard">


        {/* =================================================
            HEADER
            ================================================= */}
        <AdminHeader
          backTo="/admin"
          backLabel="Dashboard"
        />


        {/* =================================================
            MAIN
            ================================================= */}

        <main className="admin-main">


          {/* =================================================
              TITLE
              ================================================= */}

          <section className="admin-title-section">

            <span className="admin-page-eyebrow">
              ADMINISTRATION
            </span>

            <h1>
              Swarnaprashana Schedule
            </h1>

            <div className="admin-title-divider"></div>

            <p>
              Manage upcoming Swarnaprashana dates.
            </p>

          </section>


          {/* =================================================
              MESSAGES
              ================================================= */}

          {error && (

            <div className="admin-error admin-message">
              {error}
            </div>

          )}


          {success && (

            <div className="admin-success admin-message">
              {success}
            </div>

          )}


          {/* =================================================
              ADD DATE
              ================================================= */}

          <section className="admin-add-card">

            <div className="admin-section-header">

              <div>

                <span className="admin-section-label">
                  SCHEDULE
                </span>

                <h2 className="admin-card-heading">
                  Add New Date
                </h2>

              </div>

            </div>


            <form
              onSubmit={handleAddDate}
              className="admin-add-form"
            >

              <div className="admin-form-group">

                <label htmlFor="new-date">
                  Select Date
                </label>

                <input
                  id="new-date"
                  type="date"
                  value={newDate}
                  onChange={(e) =>
                    setNewDate(e.target.value)
                  }
                  required
                />

              </div>


              <button
                type="submit"
                disabled={loading}
                className="admin-primary-btn"
              >

                {loading
                  ? "Adding..."
                  : "Add Date"}

              </button>

            </form>

          </section>


          {/* =================================================
              SCHEDULED DATES
              ================================================= */}

          <section className="admin-schedule-card">

            <div className="admin-schedule-heading">

              <div>

                <span className="admin-section-label">
                  CURRENT SCHEDULE
                </span>

                <h2>
                  Scheduled Dates
                </h2>

              </div>

              <span className="admin-count">
                {dates.length}
                {dates.length === 1
                  ? " date"
                  : " dates"}
              </span>

            </div>


            {loadingDates ? (

              <div className="admin-loading">

                <div className="admin-spinner"></div>

                <p>
                  Loading dates...
                </p>

              </div>

            ) : dates.length === 0 ? (

              <div className="admin-empty">

                <div className="admin-empty-icon">
                  📅
                </div>

                <h3>
                  No dates scheduled
                </h3>

                <p>
                  Add a Swarnaprashana date above
                  to create the schedule.
                </p>

              </div>

            ) : (

              <div className="admin-date-list">

                {dates.map((item) => (

                  <div
                    key={item.id}
                    className="admin-date-row"
                  >

                    {editingId === item.id ? (

                      <div className="admin-edit-row">

                        <input
                          type="date"
                          value={editingDate}
                          onChange={(e) =>
                            setEditingDate(
                              e.target.value
                            )
                          }
                        />

                        <button
                          onClick={() =>
                            handleUpdateDate(
                              item.id
                            )
                          }
                          disabled={loading}
                          className="admin-save-btn"
                        >
                          Save
                        </button>

                        <button
                          onClick={cancelEditing}
                          disabled={loading}
                          className="admin-cancel-btn"
                        >
                          Cancel
                        </button>

                      </div>

                    ) : (

                      <>

                        <div className="admin-date-info">

                          <div className="admin-date-icon">
                            📅
                          </div>

                          <div className="admin-date-text">

                            <strong>
                              {formatDate(
                                item.date
                              )}
                            </strong>

                            <span>
                              {getWeekday(
                                item.date
                              )}
                            </span>

                          </div>

                        </div>


                        <div className="admin-actions">

                          <button
                            onClick={() =>
                              startEditing(item)
                            }
                            className="admin-edit-btn"
                          >
                            Edit
                          </button>

                          <button
                            onClick={() =>
                              handleDeleteDate(
                                item.id
                              )
                            }
                            disabled={loading}
                            className="admin-delete-btn"
                          >
                            Delete
                          </button>

                        </div>

                      </>

                    )}

                  </div>

                ))}

              </div>

            )}

          </section>


        </main>

      </div>

    </div>

  );
}


export default AdminSwarnaprashana;